import './HowTo.sass';

import React, { FC, useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useRoute, useRouter } from 'react-router5';

import { Button, Header, InlineHeader, List, ListItem, ScrollView } from '$uikit';
import { authSelector } from '$store/auth';
import { IcChevron16 } from '$assets';
import { HOWTO } from '$shared/constants/pages';
import { useCurrentLang, useTranslator } from '$hooks';

const DataRU: any[] = [
  {
    id: 'common',
    title: 'Общая информация',
    items: [
      {
        id: 'about',
        title: 'О платформе',
        items: [
          {
            id: 'about',
            title: 'О платформе',
            content: (
              <>
                Ton.Place — крипто социальная сеть с эксклюзивным контентом.
                <br />
                <br />
                <ul>
                  <li>
                    Оплата в криптовалюте
                    <a
                      href="https://coinmarketcap.com/currencies/toncoin/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      TON
                    </a>
                    ;
                  </li>
                  <li>Развлекательный и эротический контент;</li>
                  <li>Низкая комиссия для авторов — 10%.</li>
                </ul>
              </>
            ),
          },
        ],
      },
      {
        id: 'registration',
        title: 'Регистрация',
        items: [
          {
            id: 'registration',
            title: 'Регистрация',
            content: (
              <>
                Вы можете зарегистрироваться через аккаунт{' '}
                <a href="https://telegram.org" target="_blank" rel="noreferrer">
                  Telegram
                </a>{' '}
                или{' '}
                <a href="http://mail.google.com" target="_blank" rel="noreferrer">
                  Google
                </a>
                .
                <blockquote>
                  Аккаунт Ton.Place привязывается к аккаунту Telegram или Google. При
                  утере или удалении аккаунта Telegram / Google, также теряется доступ
                  к Ton.Place.
                </blockquote>
                <br />
                <br />
                <b>Этапы регистрации:</b>
                <ol>
                  <li>
                    Открываем сайт{' '}
                    <a href="https://ton.place/" target="_blank" rel="noreferrer">
                      https://ton.place
                    </a>
                    , нажимаем «Войти через Telegram»;
                  </li>
                  <li>
                    Вводим свой номер телефона в Telegram, нажимаем «Далее»;
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/telegram_auth.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>В Telegram приходит запрос на активацию, нажимаем «Принять»;</li>
                  <li>
                    Возвращайтесь в браузер на страницу Ton.Place. Нажмите на кнопку
                    «Войти через Telegram» и подтвердите вход;
                  </li>
                  <li>Заполняем форму регистрации (Имя, Фамилия, Пол, Дата рождения);</li>
                  <li>Аккаунт создан 😎.</li>
                </ol>
              </>
              /* Тут надо добавить видео: Видеоинструкция: как зарегистрироваться через Telegram?*/
            ),
          },
        ],
      },
      {
        id: 'official_bots' /* Тут задал айдишник*/,
        title: 'Официальные боты и сообщества',
        items: [
          {
            id: 'official_bots' /* Тут задал айдишник*/,
            title: 'Официальные боты и сообщества',
            content: (
              <>
                <blockquote>
                  Внимание!{' '}
                  <b>Используйте только официальных Telegram ботов Ton.Place.</b>
                  <br />
                  Взаимодействие со сторонними ботами может привести к потере средств
                  и утрате аккаунта.
                </blockquote>
                <br />
                <b>Официальные Telegram боты</b>
                <ul>
                  <li>
                    Для авторизации и уведомлений:{' '}
                    <a href="https://t.me/tonplace_bot" target="_blank" rel="noreferrer">
                      https://t.me/tonplace_bot
                    </a>
                  </li>
                  <li>
                    Поддержка:{' '}
                    <a
                      href="https://t.me/tonplacehelpbot"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://t.me/tonplacehelpbot
                    </a>
                  </li>
                </ul>
                <br />
                <b>Официальные Telegram каналы и чаты</b>
                <ul>
                  <li>
                    Ton.Place:{' '}
                    <a href="https://t.me/ton_place_ru" target="_blank" rel="noreferrer">
                      https://t.me/ton_place_ru
                    </a>
                  </li>
                  <li>
                    Ton.Place Чат:{' '}
                    <a
                      href="https://t.me/ton_place_discuss"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://t.me/ton_place_discuss
                    </a>
                  </li>
                </ul>
                <br />
                <b>Официальные сообщества</b>
                <ul>
                  <li>
                    Ton.Place:{' '}
                    <a href="https://ton.place/team" target="_blank" rel="noreferrer">
                      https://ton.place/team
                    </a>
                  </li>
                  <li>
                    Ton.Place в VK:{' '}
                    <a href="https://vk.com/tonplace" target="_blank" rel="noreferrer">
                      https://vk.com/tonplace
                    </a>
                  </li>
                  <li>
                    Ton.Place в Instagram:{' '}
                    <a
                      href="https://instagram.com/ton.place_models"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://instagram.com/ton.place_models
                    </a>
                  </li>
                </ul>
              </>
            ),
          },
        ],
      },
      {
        id: 'about_ton',
        title: 'О TON',
        items: [
          {
            id: 'about',
            title: 'Что такое TON и Toncoin?',
            content: (
              <>
                <a href="https://ru.ton.org/" target="_blank" rel="noreferrer">
                  TON
                </a>{' '}
                (Toncoin) — Основная криптовалюта блокчейна TON (The Open Network). Это
                Proof-of-Stake блокчейн третьего поколения. Он был разработан в 2018 году
                братьями Дуровыми, основателями Telegram Messenger. В 2020 году сеть была
                передана открытому сообществу TON, которое теперь занимается её поддержкой
                и развитием.
                <br />
                <br />
                Узнать данные о цене монеты Toncoin{' '}
                <a
                  href="https://coinmarketcap.com/currencies/toncoin/"
                  target="_blank"
                  rel="noreferrer"
                >
                  здесь
                </a>
                .
                <br />
                Больше информации на официальном сайте:{' '}
                <a href="https://ru.ton.org/" target="_blank" rel="noreferrer">
                  ton.org
                </a>
              </>
            ),
          },
          {
            id: 'wallet',
            title: 'Как создать кошелек для TON?',
            content: (
              <>
                <a href="https://tonkeeper.com" target="_blank" rel="noreferrer">
                  Tonkeeper
                </a>{' '}
                — криптовалютный кошелек, самый простой способ, чтобы хранить, получать и
                отправлять Toncoin.
                <br />
                <br />
                <ol>
                  <li>
                    Скачайте приложение в{' '}
                    <a
                      href="https://apps.apple.com/us/app/tonkeeper/id1587742107"
                      target="_blank"
                      rel="noreferrer"
                    >
                      App Store
                    </a>{' '}
                    или{' '}
                    <a
                      href="https://play.google.com/store/apps/details?id=com.ton_keeper"
                      target="_blank"
                      rel="noreferrer"
                    >
                      GooglePlay
                    </a>
                    .
                  </li>
                  <li>
                    Открываем Tonkeeper и нажимаем на кнопку «подключить кошелёк», далее
                    на кнопку «создать новый кошелёк».
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_new.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_new2.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Возьмите бумагу и ручку. На следующем экране появится ваш секретный
                    ключ (seed-фраза) из 24 слов.
                    <blockquote>
                      Важно! Запишите эти слова в правильной последовательности
                      и сохраните в надёжном месте. При потере телефона или удалении
                      приложения,{' '}
                      <b>
                        восстановить кошелек и получить доступ к средствам можно только
                        при помощи seed-фразы
                      </b>
                      .
                    </blockquote>
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_seed.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Для проверки правильности вашего ключа вы должны ввести 3 слова
                    из seed-фразы под указанными номерами.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_seed_check.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Далее создаём PIN-код для удобного и безопасного подтверждения
                    платежей.
                  </li>
                  <li>
                    Готово! Ваш уникальный адрес кошелька отобразится при нажатии
                    на кнопку «Получить».
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_receive.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                </ol>
              </>
            ),
          },
          {
            id: 'buy',
            title: 'Как приобрести TON?',
            content: (
              <>
                <ul>
                  <li>
                    Самый простой способ: воспользуйтесь{' '}
                    <a href="https://t.me/CryptoBot" target="_blank" rel="noreferrer">
                      @CryptoBot
                    </a>{' '}
                    — P2P обмен в Telegram боте.
                    <br />
                    Чтобы купить Toncoin, вам нужно выполнить несколько действий:
                    <ol>
                      <li>
                        Запустите{' '}
                        <a href="https://t.me/CryptoBot" target="_blank" rel="noreferrer">
                          @CryptoBot
                        </a>
                        .
                      </li>
                      <li>Зайдите в раздел «Маркет».</li>
                      <li>Нажмите «Купить».</li>
                      <li>Выберите интересующую вас криптовалюту.</li>
                      <li>Выберите платёжную систему, с которой вам удобно работать.</li>
                      <li>
                        Выберите объявление с устраивающим вас курсом и нажмите на него.
                      </li>
                    </ol>
                    Сделка проходит следующим образом: вы переводите деньги продавцу на
                    его банковскую карту, а продавец отправляет Toncoin на ваш счёт в{' '}
                    <a href="https://t.me/CryptoBot" target="_blank" rel="noreferrer">
                      @CryptoBot
                    </a>
                    , после чего вы сможете вывести монеты в{' '}
                    <a href="https://tonkeeper.com" target="_blank" rel="noreferrer">
                      Tonkeeper
                    </a>
                    .
                  </li>
                  <li>
                    <a href="https://ftx.com" target="_blank" rel="noreferrer">
                      FTX
                    </a>
                    ,{' '}
                    <a href="https://exmo.me" target="_blank" rel="noreferrer">
                      EXMO
                    </a>
                    ,{' '}
                    <a href="https://okx.com" target="_blank" rel="noreferrer">
                      OKX
                    </a>{' '}
                    — меняйте TON и другие монеты (например, BTC, ETH), выводите на карту
                    или используйте P2P обмен (необходима верификация личности).
                  </li>
                  <li>
                    <a href="https://mercuryo.io" target="_blank" rel="noreferrer">
                      Mercuryo
                    </a>
                    ,{' '}
                    <a href="https://neocrypto.net" target="_blank" rel="noreferrer">
                      Neocrypto
                    </a>{' '}
                    — пополнение и вывод на банковскую карту (необходима верификация
                    личности, на данный момент не работает для российских карт).
                  </li>
                </ul>
              </>
            ),
          },
        ],
      },
      {
        id: 'security',
        title: 'Безопасность',
        items: [
          {
            id: 'security',
            title: 'Безопасность',
            content: (
              <>
                Регистрация и вход в аккаунт Ton.Place осуществляется через Telegram или
                через Google. За вашей страницей закрепляется индивидуальный токен
                доступа, который равносилен паролю.
                <blockquote>
                  Ни в коем случае не передавайте ваш токен доступа третьим лицам.
                  Ton.Place никогда не запросит ваш токен доступа.
                </blockquote>
                <br />
                Если вы подозреваете, что кто-то вошел в ваш аккаунт, завершите активные
                сессии в настройках, а также в официальном боте Telegram с галочкой
                верификации. Каждый раз, когда совершается новый вход в аккаунт Ton.Place,
                вам приходят уведомления{' '}
                <a href="https://t.me/tonplace_bot" target="_blank" rel="noreferrer">
                  в нашем Telegram боте
                </a>
                .
              </>
            ),
          },
          {
            id: 'sessions',
            title: 'Просмотр и завершение активных сессий на Ton.Place',
            content: (
              <>
                <b>Активная сессия</b> означает, что в ваш аккаунт выполнен вход
                на определенном устройстве. Все активные сессии можно посмотреть
                в настройках («Еще» - «Настройки» - «Активные сессии»). При необходимости
                вы можете завершить любую активную сессию. Когда вы завершаете активную
                сессию, автоматически происходит выход из аккаунта на выбранном
                устройстве.
              </>
            ),
          },
          {
            id: 'sessions_tg',
            title: 'Завершение активных сессий в Telegram',
            content: (
              <>
                <ol>
                  <li>
                    Откройте Telegram и введите «Telegram» в поиске. Нажмите на бота.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/sessions_tg_search_ru.jpg').default +
                          '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Проверьте, что бот выглядит так:
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/sessions_tg_bot_ru.jpg').default +
                          '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Найдите сообщение с кнопкой «Завершить сессию» или «Terminate Session»
                    и нажмите на кнопку.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/sessions_tg_terminate_ru.jpg').default +
                          '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                </ol>
              </>
            ),
          },
          {
            id: 'sessions_notify',
            title: 'Уведомления о входе',
            content: (
              <>
                При входе в аккаунт Ton.Place через Telegram с нового устройства
                вы получите сообщение в нашем Telegram боте, если он активирован
                и включены уведомления.
                <div
                  className="HowTo__image"
                  style={{
                    backgroundImage:
                      'url("' +
                      require('./assets/sessions_bot_notify_ru.jpg').default +
                      '")',
                    paddingTop: '81%',
                  }}
                />
              </>
            ),
          },
        ],
      },
      {
        id: 'staking',
        title: 'Стейкинг',
        items: [
          {
            id: 'info',
            title: 'Стейкинг',
            content: (
              <>
                <b>Стейкинг</b> — это способ пассивного заработка, при котором держатели
                криптовалюты отправляют свои монеты на подтверждение транзакций в
                блокчейне и получают за это доход с комиссий.
                <blockquote>
                  Выполните два условия, чтобы участвовать в стейкинге:
                  <ul>
                    <li>Оплатите подписку</li>
                    <li>Пополните баланс аккаунта в Ton.Place минимум на 1 TON.</li>
                  </ul>
                </blockquote>
              </>
            ),
          },
          {
            id: 'how',
            title: 'Как работает стейкинг на Ton.Place?',
            content: (
              <>
                Все просто: оставьте минимум 1 TON на балансе Ton.Place и в течение 2-4
                дней вы получите “процент на остаток”. Годовой доход со стейкинга составит
                примерно 12%.
                <br />
                <br />
                Стейкинг запускается заново каждые 72 часа. Перед началом каждого цикла
                баланс пользователей в Ton.Place фиксируется, и определенная сумма
                отправляется на стейкинг. По завершению цикла стейкинга, если вы не
                выводили средства с баланса, вам придет доход. Награда за участие
                в стейкинге распределяется между пользователями Ton.Place в зависимости
                от количества TON на балансе.
                <blockquote>
                  Важно! Если вы выводите средства с баланса до зачисления со стейкинга,
                  то ваши монеты не будут учитываться, и соответственно доход вы
                  не получите.
                </blockquote>
              </>
            ),
          },
        ],
      },
      {
        id: 'referral',
        title: 'Реферальная программа',
        items: [
          {
            id: 'referral',
            title: 'Реферальная программа',
            content: (
              <>
                Если у вас оплачена подписка Ton.Place Медиа, приглашайте друзей
                в Ton.Place по вашей уникальной ссылке и зарабатывайте TON. За каждого
                пользователя, который зарегистрируется по реферальной ссылке и оплатит
                подписку, вы получите 0.4 TON / месяц, а также 2.5% с его покупок
                и дохода.
                <blockquote>
                  Реферальная программа доступна только для пользователей с оплаченной
                  подпиской Ton.Place Медиа.
                </blockquote>
                <div
                  className="HowTo__image"
                  style={{
                    backgroundImage:
                      'url("' + require('./assets/referral.png').default + '")',
                    paddingTop: '70%',
                  }}
                />
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    id: 'users',
    title: 'Для пользователей',
    items: [
      {
        id: 'subscription',
        title: 'Подписки и платный контент',
        items: [
          {
            id: 'subscription',
            title: 'Подписки и платный контент',
            content: (
              <>
                Без подписки вы сможете:
                <ul>
                  <li>просматривать, комментировать и лайкать бесплатные посты;</li>
                  <li>публиковать посты без монетизации;</li>
                  <li>
                    подписываться на других пользователей, кроме верифицированных моделей
                    18+;
                  </li>
                  <li>
                    отправлять сообщения другим пользователям, кроме верифицированных
                    моделей 18+.
                  </li>
                </ul>
              </>
            ),
          },
          {
            id: 'sub_how',
            title: 'Как оформить подписку?',
            content: (
              <>
                Оформить подписку можно{' '}
                <a
                  href="https://ton.place/subscriptions"
                  target="_blank"
                  rel="noreferrer"
                >
                  здесь
                </a>{' '}
                . Доступны два способа оплаты:
                <ol>
                  <li>
                    <b>Любой банковской картой.</b>
                  </li>
                  <li>
                    <b>Криптовалютой TON через кошелёк Tonkeeper.</b>
                  </li>
                </ol>
                Отменить или добавить еще одну подписку в настройках в любой момент.
              </>
            ),
          },
          {
            id: 'sub_media' /* Изменил айди, старый был kinds */,
            title: 'Ton.Place Медиа',
            content: (
              <>
                Открывает эксклюзивный контент в Ton.Place. С подпиской Медиа вы сможете:
                <ul>
                  <li>
                    просматривать, комментировать и лайкать посты для Медиа подписчиков;
                  </li>
                  <li>публиковать и монетизировать контент;</li>
                  <li>создавать сообщества.</li>
                </ul>
              </>
            ),
          },
          {
            id: 'sub_erotic' /* Добавил блок и айди */,
            title: 'Ton.Place Эротика',
            content: (
              <>
                Открывает публикации всех верифицированных моделей 18+ в Ton.Place. Каждая
                девушка, чьи посты отображаются по подписке Эротика, подтвердила личность.
                С подпиской Эротика вы сможете:
                <ol>
                  <li>просматривать, комментировать и лайкать посты моделей 18+;</li>
                  <li>отправлять сообщения и подписываться на моделей.</li>
                </ol>
              </>
            ),
          },
          {
            id: 'sub_sponsor' /* Добавил блок и айди */,
            title: 'Ton.Place Спонсор',
            content: (
              <>
                Открывает доступ к публикациям исключительно для спонсоров
                конкретного автора. Каждый автор самостоятельно подключает персональную
                подписку и устанавливает цену.
              </>
            ),
          },
          /* ! Тут нужно добавить видео в конце блока и можно разкомментить.
          {
            id: 'how_buy',
            title: 'Как купить контент в личных сообщениях?',
            content: (
              <>
                Если вам пришло платное сообщение, вы можете купить его за
                указанную цену в TON и увидеть скрытый контент.
                Посмотрите видео как купить контент в личных сообщениях:
              </>
            ),
          },
          */
        ],
      },
      {
        id: 'balance',
        title: 'Баланс',
        items: [
          {
            id: 'balance',
            title: 'Баланс',
            content: (
              <>
                <a href="/other?w=balance" target="_blank">
                  Баланс
                </a>{' '}
                — это средства, которые находятся у пользователя и с помощью которых он
                может покупать контент. Пополнить баланс и вывести средства можно
                в любой момент. Баланс отображается в TON.
                <div
                  className="HowTo__image"
                  style={{
                    backgroundImage:
                      'url("' + require('./assets/balance.png').default + '")',
                    paddingTop: '70%',
                  }}
                />
              </>
            ),
          },
          {
            id: 'top_up',
            title: 'Как пополнить баланс?',
            content: (
              <>
                Во вкладке{' '}
                <a href="/other?w=balance" target="_blank">
                  Баланс
                </a>{' '}
                нажмите на кнопку{' '}
                <a href="/other?w=top_up" target="_blank">
                  Пополнить
                </a>
                .
                <ul>
                  <li>
                    <b>Если у вас уже есть TON</b>, переведите их на адрес
                    кошелька Ton.Place.
                    <blockquote>
                      Внимание! Обязательно <b>укажите комментарий при переводе</b>, чтобы
                      избежать потери средств. Комментарий — это уникальный идентификатор
                      пользователя, с помощью которого средства зачислятся именно на ваш
                      аккаунт.
                      <br />
                      <br />
                      Многие сервисы не поддерживают комментарии к транзакциям, поэтому
                      рекомендуем использовать кошелек{' '}
                      <a href="https://tonkeeper.com" target="_blank" rel="noreferrer">
                        Tonkeeper
                      </a>
                      , где есть возможность указать комментарий при переводе средств.
                    </blockquote>
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/balance_comment.png').default +
                          '")',
                        paddingTop: '70%',
                      }}
                    />
                  </li>
                  <li>
                    <b>Если у вас есть другая криптовалюта</b>, вы можете обменять ее
                    на TON с помощью{' '}
                    <a
                      href="https://pancakeswap.finance/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      PancakeSwap
                    </a>{' '}
                    и пополнить баланс Ton.Place через Binance Smart Chain.
                    <blockquote>
                      Внимание! При пополнении через Binance Smart Chain не нужно
                      указывать комментарий, так как вам выдаётся{' '}
                      <b>временный адрес на 1 час</b>. Необходимо пополнить баланс за
                      отведённое время.
                    </blockquote>
                  </li>
                  <li>
                    <b>Если у вас нет TON</b>, купите любое количество монет в Telegram
                    ботах{' '}
                    <a
                      href="https://t.me/CryptoBot?start=r-1325-market"
                      target="_blank"
                      rel="noreferrer"
                    >
                      @CryptoBot
                    </a>{' '}
                    или{' '}
                    <a href="https://t.me/wallet" target="_blank" rel="noreferrer">
                      @wallet
                    </a>
                    , а также через{' '}
                    <a href="https://mercuryo.io" target="_blank" rel="noreferrer">
                      Mercuryo
                    </a>{' '}
                    или{' '}
                    <a href="https://neocrypto.net" target="_blank" rel="noreferrer">
                      Neocrypto
                    </a>
                    . Затем, переведите средства на кошелек Tonkeeper и сможете пополнить
                    баланс Ton.Place.
                  </li>
                </ul>
                Комиссия за перевод с кошелька Tonkeeper составит примерно 0.1 TON.
              </>
            ),
          },
          {
            id: 'withdraw',
            title: 'Как вывести средства с баланса?',
            content: (
              <>
                <ol>
                  <li>
                    Во вкладке{' '}
                    <a href="/other?w=balance" target="_blank">
                      Баланс
                    </a>{' '}
                    нажмите на кнопку{' '}
                    <a href="/other?w=withdraw" target="_blank">
                      Вывести
                    </a>
                    .
                  </li>
                  <li>
                    Введите количество TON для вывода. Комиссия за вывод — 0.02 TON.
                  </li>
                  <li>
                    Введите адрес вашего личного кошелька в сети TON. Например, это может
                    быть кошелек{' '}
                    <a href="https://tonkeeper.com" target="_blank" rel="noreferrer">
                      Tonkeeper
                    </a>{' '}
                    в мобильном приложении или кошелек в Telegram боте{' '}
                    <a href="https://t.me/wallet" target="_blank" rel="noreferrer">
                      @wallet
                    </a>
                    . Вы также можете выбрать другой кошелек из официального каталога{' '}
                    <a href="https://ton.app/wallets" target="_blank" rel="noreferrer">
                      TON Apps
                    </a>
                    .
                  </li>
                </ol>
              </>
            ),
          },
        ],
      },
      /*{ ! Убрали эти блоки в архив
      id: 'navigation',
      title: 'Навигация по платформе',
      items: [
        {
          id: 'follow',
          title: 'На кого я могу подписаться?',
          content: (
            <>
              С активной подпиской Ton.Place Медиа вы можете следить за любым
              количеством авторов с развлекательным контентом.
              <br />
              <br />
              Если у вас оформлена подписка Ton.Place Эротика, для вас открыт доступ к
              публикациям всех верифицированных моделей 18+.
            </>
          ),
        },
        {
          id: 'verification',
          title: 'Что означает галочка рядом с именем профиля?',
          content: (
            <>
              Это означает, что профиль прошел верификацию и данные в аккаунте
              действительно принадлежат настоящему владельцу аккаунта.
              <br />
              <br />
              Верификацию проходят:
              <ul>
                <li>
                  Медийные личности или сообщества, которые любят делиться
                  развлекательным и информационным контентом;
                </li>
                <li>Модели 18+, которые любят делиться эротическими фото и видео.</li>
              </ul>
            </>
          ),
        },
        {
          id: 'buy',
          title: 'Какой контент я могу купить?',
          content: (
            <>
              Покупая подписку, вы оплачиваете доступ ко всем публикациям Ton.Place
              определенного типа (Медиа или Эротика). Кроме этого, вы можете купить
              эксклюзивный контент у авторов в личных сообщениях. Оплата фото или видео,
              полученных в чате, производится в TON.
            </>
          ),
        },
        {
          id: 'pay_messages',
          title: 'Как оплатить контент в личных сообщениях?',
          content: (
            <>
              Если вам пришло платное сообщение, вы можете купить его за указанную
              цену в TON и увидеть скрытый контент.
              Посмотрите видео как купить контент в личных сообщениях:
            </>
          ),
        },
      ],
    },*/
    ],
  },
  {
    id: 'creators',
    title: 'Для создателей контента',
    items: [
      {
        id: 'subscription',
        title: 'Подписка',
        items: [
          {
            id: 'subscription',
            title: 'Подписка',
            content: (
              <>
                Если вы проходите верификацию как модель 18+ и собираетесь делиться
                эротическим контентом, подписка не нужна.
                <br />
                <br />
                Если вы хотите создавать информационный и развлекательный контент,
                необходимо оформить подписку.
                <br />
                <br />
                Ton.Place Медиа — базовая подписка, которой достаточно для того, чтобы
                публиковать и монетизировать развлекательный контент. Оплатить подписку
                можно{' '}
                <a
                  href="https://ton.place/subscriptions"
                  target="_blank"
                  rel="noreferrer"
                >
                  здесь
                </a>
                .
              </>
            ),
          },
        ],
      },
      {
        id: 'monetization',
        title: 'Монетизация',
        items: [
          {
            id: 'monetization',
            title: 'Подписка',
            content: (
              <>
                Есть несколько способов монетизировать ваш контент: через подписки
                Ton.Place Медиа или Ton.Place Эротика, через персональные подписки
                Ton.Place Спонсор и через продажу личных сообщений. Создатели контента
                зарабатывают в TON.
              </>
            ),
          },
          {
            id: 'normal',
            title: 'Монетизация для авторов развлекательного контента',
            content: (
              <>
                <b>Ежедневные выплаты</b>
                <ul>
                  <li>
                    Авторам выплачивается 90% общего дохода платформы от подписок
                    Ton.Place Медиа, который распределяется пропорционально популярности
                    их контента.
                  </li>
                  <li>
                    Платформа удерживает комиссию 5%, а также по 2.5% выплачивается тем,
                    кто пригласил подписчика и автора (по реферальной программе). То есть,
                    общая комиссия — всего 10%.
                  </li>
                  <li>
                    Выплаты за активность подписчиков под публикациями на{' '}
                    <a
                      href="https://ton.place/other?w=balance"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Баланс
                    </a>{' '}
                    Ton.Place ежедневно в 03:00 по МСК.
                  </li>
                </ul>
                <b>Персональные подписки</b>
                <ul>
                  <li>
                    Подключите подписку Ton.Place Спонсор в Настройках и самостоятельно
                    установите цену.
                  </li>
                  <li>
                    Когда кто-то купит у вас подписку Ton.Place Спонсор, доход придет
                    на ваш Баланс сразу.
                  </li>
                  <li>Ton.Place удерживает комиссию 10%.</li>
                </ul>
                <b>Платные личные сообщения</b>
                <ul>
                  <li>
                    Зарабатывайте на отправке платного контента (фото или видео) в личных
                    сообщениях. Вы сами устанавливаете цену за сообщение, но не менее
                    0.1 TON. Максимальная цена не ограничена.
                  </li>
                  <li>
                    Пользователь получает сообщение с ценой и скрытым контентом. После
                    оплаты сообщения в TON, содержание сообщения откроется.
                  </li>
                  <li>
                    Комиссия 10% (5% платформы и 5% на реферальную программу) вычитается
                    сразу. Если вы установили цену 100 TON за сообщение, то вам на счет
                    зачислится 90 TON.
                  </li>
                  <li>
                    Выплаты за продажу платного контента в личных сообщениях поступают на{' '}
                    <a
                      href="https://ton.place/other?w=balance"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Баланс
                    </a>{' '}
                    Ton.Place моментально.
                  </li>
                </ul>
                <b>Реферальная программа</b>
                <ul>
                  <li>
                    Приглашайте друзей или подписчиков из других соцсетей по{' '}
                    <a href="/invite" target="_blank" rel="noreferrer">
                      вашей уникальной реферальной ссылке
                    </a>
                    .
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/referral.png').default + '")',
                        paddingTop: '70%',
                      }}
                    />
                  </li>
                  <li>
                    Если ваш друг зарегистрируется и оплатит подписку, то вы будете
                    ежемесячно получать 0.4 TON на баланс Ton.Place, а также 2.5% с его
                    покупок и доходов.
                  </li>
                </ul>
              </>
            ),
          },
          {
            id: 'adult',
            title: 'Монетизация для моделей 18+',
            content: (
              <>
                <b>Ежедневные выплаты</b>
                <ul>
                  <li>
                    Моделям выплачивается 90% общего дохода от подписок Ton.Place Эротика,
                    который распределяется пропорционально популярности их контента.
                  </li>
                  <li>
                    Платформа удерживает комиссию 10%, которая направляется на поддержание
                    и развитие соцсети.
                  </li>
                  <li>
                    Выплаты за активность подписчиков под публикациями поступают на{' '}
                    <a
                      href="https://ton.place/other?w=balance"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Баланс
                    </a>{' '}
                    Ton.Place ежедневно в 03:00 по МСК.
                  </li>
                </ul>
                <b>Платные личные сообщения</b>
                <ul>
                  <li>
                    Зарабатывайте на отправке платного контента (фото или видео) в личных
                    сообщениях. Вы сами устанавливаете цену за сообщение, но не менее
                    0.1 TON. Максимальная цена не ограничена.
                  </li>
                  <li>
                    Пользователь получает сообщение с ценой и скрытым контентом. После
                    оплаты сообщения в TON, содержание сообщения откроется.
                  </li>
                  <li>
                    Комиссия платформы 10% вычитается сразу. Если вы установили цену
                    100 TON за сообщение, то вам на счет зачислится 90 TON.
                  </li>
                  <li>
                    Выплаты за продажу платного контента в личных сообщениях поступают на{' '}
                    <a
                      href="https://ton.place/other?w=balance"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Баланс
                    </a>{' '}
                    Ton.Place моментально.
                  </li>
                </ul>
              </>
            ),
          },
        ],
      },
      {
        id: 'balance',
        title: 'Баланс',
        items: [
          {
            id: 'balance',
            title: 'Баланс',
            content: (
              <>
                Выплаты за активность вашей аудитории и продажу личных сообщений поступают
                на{' '}
                <a
                  href="https://ton.place/other?w=balance"
                  target="_blank"
                  rel="noreferrer"
                >
                  Баланс
                </a>
                Ton.Place.
              </>
            ),
          },
          {
            id: 'withdraw',
            title: 'Вывод средств',
            content: (
              <>
                Во вкладке{' '}
                <a href="/other?w=balance" target="_blank">
                  баланс
                </a>{' '}
                нажмите на кнопку{' '}
                <a href="/other?w=withdraw" target="_blank">
                  вывести
                </a>
                .
                <br />
                <br />
                Вывод средств доступен в любое время. Просто укажите адрес кошелька на
                TON, куда необходимо сделать вывод.
              </>
            ),
          },
          {
            id: 'exchange',
            title: 'Как обменять TON на обычные деньги?',
            content: (
              <>
                Как только средства с Баланса поступили на ваш кошелек Tonkeeper или
                другой кошелек для TON, вы можете обменять их на рубли, доллары и другие
                валюты.
                <br />
                <br />
                <br />
                Обменивать TON, рубли, доллары и прочие валюты можно через:
                <ol>
                  <li>
                    <a
                      href="https://t.me/CryptoBot?start=r-1325-market"
                      target="_blank"
                      rel="noreferrer"
                    >
                      @CryptoBot
                    </a>{' '}
                    — Telegram бот. Оставляйте заявку и обменивайтесь с другими
                    пользователями напрямую (P2P обмен). Инструкция для вывода TON и
                    обмена на обычные деньги:
                    <br />
                    <div>
                      <b>Шаг 1.</b>
                      <br /> Запустите бота с помощью команды /start или кнопкой «Начать».
                    </div>
                    <div>
                      <b>Шаг 2.</b>
                      <br /> Нажмите «Кошелек», далее «Пополнить». Скопируйте адрес
                      кошелька из бота и вставьте его во вкладке Вывод на Ton.Place.
                      Обязательно укажите сумму TON, которую хотите вывести.
                    </div>
                    <div>
                      <b>Шаг 3.</b>
                      <br /> Когда TON зачислятся на ваш кошелек в CryptoBot, выберите
                      «Маркет» в главном меню. Далее, нажмите «Продать». Выберите валюту,
                      на которую вы хотите обменять TON (RUB, USD, EUR, BYN, UAH, KYZ). Вы
                      можете позже изменить валюту Маркета в настройках.
                    </div>
                    <div>
                      <b>Шаг 4.</b>
                      <br /> Выберите один из способов оплаты, чтобы обменять TON на
                      выбранную вами валюту (например, Tinkoff, Sberbank, и т.д.).
                    </div>
                    <div>
                      <b>Шаг 5.</b>
                      <br /> Выберите подходящее предложение из списка. Например:
                      <div
                        className="HowTo__image"
                        style={{
                          backgroundImage:
                            'url("' +
                            require('./assets/crypto_bot_price.png').default +
                            '")',
                          paddingTop: '11%',
                        }}
                      />
                    </div>
                    Доступный объем у этого предложения — 945 TON по цене 194 ₽ / TON.
                    Лимит от 10 000 ₽ до 99 000 ₽, то есть вы можете вывести TON минимум
                    на 10 000 ₽ и максимум на 99 000 ₽.
                    <br />
                    <br />
                    Совет:
                    <br />
                    Вы всегда можете связаться с продавцом, нажав на его никнейм.
                    Проверьте количество сделок, рейтинг и объем средств совершенных
                    продаж. Обязательно обратите внимание на условия сделки. Таким
                    образом, вы обезопасите себя от мошенников.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/crypto_bot_user.png').default +
                          '")',
                        paddingTop: '19%',
                      }}
                    />
                    <div>
                      <b>Шаг 5.</b>
                      <br /> Нажмите «Продать» и введите платежные данные, куда вы хотите
                      вывести TON. Вы можете добавить комментарий к транзакции, но это
                      необязательно.
                    </div>
                    <div>
                      <b>Шаг 6.</b>
                      <br /> Введите сумму, которую хотите вывести в TON или в выбранной
                      ранее валюте. Выберите и подтвердите платежные реквизиты, нажав на
                      «Посмотреть сделку». Ожидайте перевода средств.
                    </div>
                    <div>
                      <b>Шаг 7.</b>
                      <br /> Когда средства поступили на вашу карту, необходимо
                      подтвердить их получение и перевести необходимую сумму TON продавцу.
                      Если прошло более 15 минут с момента отправки платежных данных, а
                      средства не поступили на карту, вы можете открыть спор.
                    </div>
                  </li>
                  <li>
                    <a href="https://mercuryo.io" target="_blank" rel="noreferrer">
                      Mercuryo
                    </a>{' '}
                    — пополнение и вывод на банковскую карту (необходима верификация
                    личности). Инструкцию для вывода средств можно прочитать{' '}
                    <a
                      href="https://help.mercuryo.io/ru/articles/4675814-как-продать-крипту-и-вывести-фиат-на-карту-банка"
                      target="_blank"
                      rel="noreferrer"
                    >
                      здесь
                    </a>
                    ;
                  </li>
                  <li>
                    <a href="https://neocrypto.net" target="_blank" rel="noreferrer">
                      Neoсrypto
                    </a>{' '}
                    — пополнение и вывод на банковскую карту (необходима верификация
                    личности);
                  </li>
                  <li>
                    <a href="https://ftx.com" target="_blank" rel="noreferrer">
                      FTX
                    </a>
                    ,{' '}
                    <a href="https://exmo.me" target="_blank" rel="noreferrer">
                      EXMO
                    </a>
                    ,{' '}
                    <a href="https://okx.com" target="_blank" rel="noreferrer">
                      OKX
                    </a>{' '}
                    — меняйте TON и другие монеты (например, BTC, ETH), выводите на карту
                    или используйте P2P обмен (необходима верификация личности).
                  </li>
                </ol>
              </>
            ),
          },
        ],
      },
      {
        id: 'verification',
        title: 'Верификация',
        items: [
          {
            id: 'verification',
            title: 'Верификация',
            content: (
              <>
                Верификация — это знак подлинности аккаунта. Процесс верификации{' '}
                <b>бесплатный</b> для всех в Ton.Place.
              </>
            ),
          },
          {
            id: 'for_who',
            title: 'Кто может пройти верификацию?',
            content: (
              <>
                <ul>
                  <li>
                    Медийные личности или сообщества с развлекательным и информационным
                    контентом.
                  </li>
                  <li>Модели 18+, которые любят делиться эротическими фото и видео.</li>
                </ul>
              </>
            ),
          },
          {
            id: 'how',
            title: 'Как пройти верификацию?',
            content: (
              <>
                Подать заявку на верификацию можно{' '}
                <a href="https://ton.place/verification" target="_blank" rel="noreferrer">
                  здесь
                </a>
                .
                <br />
                <br />
                Верификация состоит из нескольких этапов:
                <ol>
                  <li>
                    <b>Модерация</b>. Необходимо указать ссылки на ваши аккаунты в других
                    соцсетях, а также вкратце рассказать о себе и о контенте, который вы
                    собираетесь публиковать в Ton.Place.
                  </li>
                  <li>
                    <b>Верификация</b>. Необходимо заполнить анкету, которая
                    обрабатывается ИИ-системой проверки личности.
                  </li>
                </ol>
              </>
            ),
          },
        ],
      },
    ],
  },
];

const DataEN: any[] = [
  {
    id: 'common',
    title: 'General Information',
    items: [
      {
        id: 'about',
        title: 'About the Platform',
        items: [
          {
            id: 'about',
            title: 'About the Platform',
            content: (
              <>
                Ton.Place is a crypto social network with exclusive content.
                <br />
                <br />
                <ul>
                  <li>
                    Supports payments in{' '}
                    <a
                      href="https://coinmarketcap.com/currencies/toncoin/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      TONCOIN
                    </a>{' '}
                    cryptocurrency;
                  </li>
                  <li>Provides entertainment and erotic content;</li>
                  <li>Charges a low commission fee of only 10%.</li>
                </ul>
              </>
            ),
          },
        ],
      },
      {
        id: 'registration',
        title: 'How to Sign Up',
        items: [
          {
            id: 'registration',
            title: 'How to Sign Up',
            content: (
              <>
                You can sign up with{' '}
                <a href="https://telegram.org" target="_blank" rel="noreferrer">
                  Telegram
                </a>{' '}
                or{' '}
                <a href="http://mail.google.com" target="_blank" rel="noreferrer">
                  Google
                </a>
                .
                <blockquote>
                  Your Ton.Place account is linked to your Google or Telegram account.
                  Losing or deleting your Telegram / Google account means losing access to
                  Ton.Place.
                </blockquote>
                <br />
                <br />
                <b>How to sign up with Telegram:</b>
                <ol>
                  <li>
                    Go to{' '}
                    <a href="https://ton.place/" target="_blank" rel="noreferrer">
                      https://ton.place
                    </a>
                    , click on “Sign Up with Telegram”;
                  </li>
                  <li>
                    Enter the phone number attached to your Telegram account, and click
                    “Next”;
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/telegram_auth.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Telegram will send a message with the request to log in on Ton.Place.
                    Press “Accept”;
                  </li>
                  <li>
                    Go back to the Ton.Place page in the browser. Click on “Sign Up with
                    Telegram” and confirm the login;
                  </li>
                  <li>Enter your first name, last name, date of birth and sex;</li>
                  <li>Done! Your account is ready 😎</li>
                </ol>
              </>
              /* Тут в ру версии: Видеоинструкция: как зарегистрироваться через Telegram?
                 хз надо ли нам на англ делать видео */
            ),
          },
        ],
      },
      {
        id: 'official_bots',
        title: 'Official bots and communities',
        items: [
          {
            id: 'official_bots',
            title: 'Official bots and communities',
            content: (
              <>
                <blockquote>
                  Attention! Only use official Ton.Place bots in Telegram. Interactions
                  with other bots may result in loss of funds.
                </blockquote>
                <br />
                <b>Official Telegram bots</b>
                <ul>
                  <li>
                    Authorization & Notifications:{' '}
                    <a href="https://t.me/tonplace_bot" target="_blank" rel="noreferrer">
                      https://t.me/tonplace_bot
                    </a>
                  </li>
                  <li>
                    Support:{' '}
                    <a
                      href="https://t.me/tonplacehelpbot"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://t.me/tonplacehelpbot
                    </a>
                  </li>
                </ul>
                <br />
                <b>Official Telegram channels</b>
                <ul>
                  <li>
                    Ton.Place:{' '}
                    <a href="https://t.me/ton_place_ru" target="_blank" rel="noreferrer">
                      https://t.me/ton_place
                    </a>
                  </li>
                  <li>
                    Ton.Place 18+:{' '}
                    <a href="https://t.me/tonplacehotru" target="_blank" rel="noreferrer">
                      https://t.me/tonplacehot
                    </a>
                  </li>
                </ul>
                <br />
                <b>Official Ton.Place News Page:</b>{' '}
                <ul>
                  <li>
                    Ton.Place:{' '}
                    <a href="https://ton.place/team" target="_blank" rel="noreferrer">
                      https://ton.place/team
                    </a>
                  </li>
                  <li>
                    Ton.Place 18+:{' '}
                    <a href="https://t.me/tonplacehotru" target="_blank" rel="noreferrer">
                      https://t.me/tonplacehot
                    </a>
                  </li>
                  <li>
                    Instagram:{' '}
                    <a
                      href="https://instagram.com/ton.place_models"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://instagram.com/ton.place_models
                    </a>
                  </li>
                </ul>
              </>
            ),
          },
        ],
      },
      {
        id: 'about_ton',
        title: 'About TON',
        items: [
          {
            id: 'about',
            title: 'What is TON and Toncoin?',
            content: (
              <>
                <a href="https://ru.ton.org/" target="_blank" rel="noreferrer">
                  TON
                </a>{' '}
                (Toncoin) is the main currency of The Open Network blockchain. It’s a 3rd
                generation Proof-of-Stake blockchain built in 2018 by the Durov brothers,
                the founders of Telegram. In 2020, TON was handed over to an open source
                community that maintains and supports its development to this day.
                <br />
                <br />
                Learn about Toncoin price{' '}
                <a
                  href="https://coinmarketcap.com/currencies/toncoin/"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
                <br />
                Find out more information on{' '}
                <a href="https://ru.ton.org/" target="_blank" rel="noreferrer">
                  the official website
                </a>
                .
              </>
            ),
          },
          {
            id: 'wallet',
            title: 'How to create a TON Wallet?',
            content: (
              <>
                <a href="https://tonkeeper.com" target="_blank" rel="noreferrer">
                  Tonkeeper
                </a>{' '}
                is a crypto wallet, a simple and convenient way to store and transfer
                Toncoin.
                <br />
                <br />
                <ol>
                  <li>
                    Download the app on{' '}
                    <a
                      href="https://apps.apple.com/us/app/tonkeeper/id1587742107"
                      target="_blank"
                      rel="noreferrer"
                    >
                      App Store
                    </a>{' '}
                    or{' '}
                    <a
                      href="https://play.google.com/store/apps/details?id=com.ton_keeper"
                      target="_blank"
                      rel="noreferrer"
                    >
                      GooglePlay
                    </a>
                    .
                  </li>
                  <li>
                    Open Tonkeeper app and press “Set up wallet”, then
                    “Create new wallet”.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_new.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_new2.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Grab a pen and paper. On the next screen, you will see a recovery
                    phrase (seed-phrase) of 24 words.
                    <blockquote>
                      Write down these words in the right order and keep this paper in a
                      safe place. If you lose your device or delete the app, you can only
                      restore your wallet with the seed-phrase.
                    </blockquote>
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_seed.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    To make sure you’ve recorded the seed-phrase correctly, enter 3 words
                    as asked on the next screen.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_seed_check.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Create a PIN-code that will be used to confirm payments and transfers.
                  </li>
                  <li>
                    All set! Find your unique wallet address by clicking on “Receive”.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/tk_receive.png').default + '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                </ol>
              </>
            ),
          },
          {
            id: 'buy',
            title: 'How to buy TON?',
            content: (
              <>
                There are multiple ways to buy TON:
                <ul>
                  <li>
                    Buy TON with a credit card on{' '}
                    <a href="https://mercuryo.io" target="_blank" rel="noreferrer">
                      Mercuryo
                    </a>{' '}
                    or{' '}
                    <a href="https://neocrypto.net" target="_blank" rel="noreferrer">
                      Neocrypto
                    </a>{' '}
                    right in Tonkeeper app.
                  </li>
                  <li>
                    <a href="https://ftx.com" target="_blank" rel="noreferrer">
                      FTX
                    </a>
                    ,{' '}
                    <a href="https://exmo.me" target="_blank" rel="noreferrer">
                      EXMO
                    </a>
                    ,{' '}
                    <a href="https://okx.com" target="_blank" rel="noreferrer">
                      OKX
                    </a>{' '}
                    exchanges are all available for purchasing TON.
                  </li>
                  <li>
                    Use Telegram bot{' '}
                    <a href="https://t.me/CryptoBot" target="_blank" rel="noreferrer">
                      @CryptoBot
                    </a>{' '}
                    for P2P exchange.
                  </li>
                </ul>
              </>
            ),
          },
        ],
      },
      {
        id: 'security',
        title: 'Security',
        items: [
          {
            id: 'security',
            title: 'Security',
            content: (
              <>
                Signing up and logging into Ton.Place is done via Telegram or Google.
                Every profile has an individual access token that serves as a password.
                <blockquote>
                  Do not give your access token to anyone. Ton.Place will never ask for
                  your access token.
                </blockquote>
                <br />
                If you suspect that somebody logged into your account, terminate the
                active sessions in settings on Ton.Place, as well as in the official
                Telegram bot with a verified badge. Every time there is a new login into
                your Ton.Place account, you receive a notification{' '}
                <a href="https://t.me/tonplace_bot" target="_blank" rel="noreferrer">
                  in our Telegram bot
                </a>
                .
              </>
            ),
          },
          {
            id: 'sessions',
            title: 'Monitoring and terminating active sessions on Ton.Place',
            content: (
              <>
                An <b>active session</b> means that you are logged into your account
                on a specific device. All active sessions are displayed in settings
                («More» - «Settings» - «Active sessions»). You can terminate any session
                if necessary. When a session is terminated, you are automatically
                logged out of the account on the selected device.
              </>
            ),
          },
          {
            id: 'sessions_tg',
            title: 'Terminating active sessions in Telegram',
            content: (
              <>
                <ol>
                  <li>
                    Open Telegram and type «Telegram» in the search bar. Click on the bot.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/sessions_tg_search.jpg').default +
                          '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Check that the bot looks like this:
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/sessions_tg_bot.jpg').default +
                          '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                  <li>
                    Find a message with a «Terminate session» button, and click
                    on the button.
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/sessions_tg_terminate.jpg').default +
                          '")',
                        paddingTop: '81%',
                      }}
                    />
                  </li>
                </ol>
              </>
            ),
          },
          {
            id: 'sessions_notify',
            title: 'Notifications about new logins',
            content: (
              <>
                When you or somebody logs into your Ton.Place account from a new device
                with Telegram, you will receive a message in our Telegram bot, given that
                it’s activated and notifications are not muted.
                <div
                  className="HowTo__image"
                  style={{
                    backgroundImage:
                      'url("' +
                      require('./assets/sessions_bot_notify.jpg').default +
                      '")',
                    paddingTop: '81%',
                  }}
                />
              </>
            ),
          },
        ],
      },
      {
        id: 'staking',
        title: 'Staking',
        items: [
          {
            id: 'info',
            title: 'Staking',
            content: (
              <>
                <b>Staking</b> helps TON users verify blockchain transactions, and allows
                participants to get passive income from transaction commissions.
                <blockquote>
                  To participate in Staking, you need to have:
                  <ul>
                    <li>A paid membership.</li>
                    <li>Minimum of 1 TON on your Ton.Place Balance.</li>
                  </ul>
                </blockquote>
              </>
            ),
          },
          {
            id: 'how',
            title: 'How does Staking work on Ton.Place?',
            content: (
              <>
                It’s simple: leave a minimum of 1 TON on your Ton.Place Balance and you
                will receive a return on the staked coins in 2-4 days. Think of it as an
                “interest rate” on your savings account. Yearly profit from Staking
                is around 12%.
                <br />
                <br />
                Staking repeats in cycles that are reset every 72 hours. Before entering
                a new cycle, we take a snapshot of all balances of Ton.Place users
                and contribute these coins to staking. Once the cycle is over, you will
                earn TON unless you withdrew funds from your Balance. Rewards for
                participating in Staking are distributed between users in proportion
                to the sum deposited on Ton.Place.
                <blockquote>
                  Important! If you withdraw your funds before receiving profit from
                  Staking, your coins will not count and, therefore, you will not get
                  a reward.
                </blockquote>
              </>
            ),
          },
        ],
      },
      {
        id: 'referral',
        title: 'Referral Program',
        items: [
          {
            id: 'referral',
            title: 'Referral Program',
            content: (
              <>
                If you have an active Ton.Place Media subscription, invite friends via
                your unique referral link and earn TON. You will receive 0.4 TON, plus
                2.5% of all the purchases and income of each user that registers with your
                referral link and purchases the subscription.
                <blockquote>
                  Referral Program is only available with an active Ton.Place Media
                  subscription. If you are a Ton.Place Erotic subscriber, you cannot earn
                  TON for referring friends.
                </blockquote>
                <div
                  className="HowTo__image"
                  style={{
                    backgroundImage:
                      'url("' + require('./assets/referral.png').default + '")',
                    paddingTop: '70%',
                  }}
                />
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    id: 'users',
    title: 'For Members',
    items: [
      {
        id: 'subscription',
        title: 'Memberships and paid content',
        items: [
          {
            id: 'subscription',
            title: 'Memberships and paid content',
            content: (
              <>
                Without a Membership you can:
                <ul>
                  <li>see, like and comment free posts;</li>
                  <li>create non-monetizable posts;</li>
                  <li>follow other users, except for verified nude models (18+);</li>
                  <li>
                    send messages to other users, except for verified nude models (18+).
                  </li>
                </ul>
              </>
            ),
          },
          {
            id: 'sub_how',
            title: 'How to become a Member?',
            content: (
              <>
                Buy a Membership{' '}
                <a
                  href="https://ton.place/subscriptions"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                . There are two ways to pay the membership fee:
                <ol>
                  <li>
                    <b>Pay with a credit card.</b>
                  </li>
                  <li>
                    <b>Pay in TON with Tonkeeper wallet.</b>
                  </li>
                </ol>
                You can cancel or buy one more membership in Settings at any moment.
              </>
            ),
          },
          {
            id: 'sub_media',
            title: 'Ton.Place Media',
            content: (
              <>
                Unlocks access to exclusive content on Ton.Place. As a Media Member
                you can:
                <ul>
                  <li>see, like and comment posts created for Media Members;</li>
                  <li>create and monetize content;</li>
                  <li>create Groups.</li>
                </ul>
              </>
            ),
          },
          {
            id: 'sub_erotic',
            title: 'Ton.Place Erotic',
            content: (
              <>
                Unlocks access to all verified nude models (18+) on Ton.Place. Every girl
                that appears in Erotic feed has confirmed her identity. As an
                Erotic Member you can:
                <ol>
                  <li>see, like and comment posts created by 18+ models;</li>
                  <li>send messages and follow 18+ models.</li>
                </ol>
              </>
            ),
          },
          {
            id: 'sub_sponsor',
            title: 'Ton.Place Sponsor',
            content: (
              <>
                Unlocks access to posts created specifically for Sponsors of a certain
                author. Any author can activate the Sponsor Membership and set the price
                on their own.
              </>
            ),
          },
          {
            id: 'how_buy',
            title: 'How to buy a paid private message?',
            content: (
              <>
                If you received a paid message, you can purchase it for the indicated
                price in TON, and see the hidden content.
              </>
            ),
          },
        ],
      },
      {
        id: 'balance',
        title: 'Balance',
        items: [
          {
            id: 'balance',
            title: 'Balance',
            content: (
              <>
                <a href="/other?w=balance" target="_blank">
                  Balance
                </a>{' '}
                shows the funds you have deposited on your Ton.Place account that can be
                used to buy membership and paid private messages. Top up or withdraw money
                at any moment.
                <div
                  className="HowTo__image"
                  style={{
                    backgroundImage:
                      'url("' + require('./assets/balance.png').default + '")',
                    paddingTop: '70%',
                  }}
                />
              </>
            ),
          },
          {
            id: 'top_up',
            title: 'How to top up the balance?',
            content: (
              <>
                Go to{' '}
                <a href="/other?w=balance" target="_blank">
                  Balance
                </a>{' '}
                and click on{' '}
                <a href="/other?w=top_up" target="_blank">
                  Top up
                </a>
                .
                <ul>
                  <li>
                    <b>If you already have TON</b>, send them to Ton.Place wallet address.
                    <blockquote>
                      Attention! Add a comment (a memo) to the transaction to avoid
                      losing funds. This comment serves as a unique user identifier that
                      directs the funds into the right account.
                      <br />
                      <br />
                      Many services do not support transaction comments. We recommend you
                      use Tonkeeper wallet that allows to include a comment to the
                      transaction.
                    </blockquote>
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' +
                          require('./assets/balance_comment.png').default +
                          '")',
                        paddingTop: '70%',
                      }}
                    />
                  </li>
                  <li>
                    <b>If you have a different cryptocurrency</b>, exchange it for TON on{' '}
                    <a
                      href="https://pancakeswap.finance/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      PancakeSwap
                    </a>{' '}
                    or top up Ton.Place balance via Binance Smart Chain.
                    <blockquote>
                      Attention! You do not need to include a comment when making
                      a transfer via Binance Smart Chain, since you get a
                      <b>temporary address for 1 hour</b>. Top up the balance during the
                      given time period.
                    </blockquote>
                  </li>
                  <li>
                    <b>If you don’t have TON</b>, buy any amount of coins in Telegram bots{' '}
                    <a
                      href="https://t.me/CryptoBot?start=r-1325-market"
                      target="_blank"
                      rel="noreferrer"
                    >
                      @CryptoBot
                    </a>{' '}
                    or{' '}
                    <a href="https://t.me/wallet" target="_blank" rel="noreferrer">
                      @wallet
                    </a>
                    , or on{' '}
                    <a href="https://mercuryo.io" target="_blank" rel="noreferrer">
                      Mercuryo
                    </a>{' '}
                    and{' '}
                    <a href="https://neocrypto.net" target="_blank" rel="noreferrer">
                      Neocrypto
                    </a>
                    . Next, transfer the funds to Tonkeeper and top up Ton.Place balance.
                  </li>
                </ul>
                Commission for transferring TON from Tonkeeper to Ton.Place is ~0.1 TON.
              </>
            ),
          },
          {
            id: 'withdraw',
            title: 'How to withdraw TON from the balance?',
            content: (
              <>
                <ol>
                  <li>
                    Go to{' '}
                    <a href="/other?w=balance" target="_blank">
                      Balance
                    </a>{' '}
                    , and click on{' '}
                    <a href="/other?w=withdraw" target="_blank">
                      Withdraw
                    </a>
                    .
                  </li>
                  <li>
                    Enter the amount of TON you’d like to withdraw. Commission charged for
                    withdrawals is ~0.02 TON.
                  </li>
                  <li>
                    Enter your TON personal wallet address. For example, it could be a
                    <a href="https://tonkeeper.com" target="_blank" rel="noreferrer">
                      Tonkeeper
                    </a>{' '}
                    wallet in a mobile app or{' '}
                    <a href="https://t.me/wallet" target="_blank" rel="noreferrer">
                      @wallet
                    </a>{' '}
                    in Telegram. There are more TON wallet options{' '}
                    <a href="https://ton.app/wallets" target="_blank" rel="noreferrer">
                      in the official TON Apps catalog
                    </a>
                    .
                  </li>
                </ol>
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    id: 'creators',
    title: 'For Creators',
    items: [
      {
        id: 'subscription',
        title: 'Membership',
        items: [
          {
            id: 'subscription',
            title: 'Membership',
            content: (
              <>
                If you are a verified 18+ model who posts erotic content, you do not need
                to purchase the membership.
                <br />
                <br />
                If you want to create info & entertainment content, you can do so with
                Ton.Place Media membership.
                <br />
                <br />
                Ton.Place Media is the basic membership that allows you to make posts and
                monetize them. Activate the membership{' '}
                <a
                  href="https://ton.place/subscriptions"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
              </>
            ),
          },
        ],
      },
      {
        id: 'monetization',
        title: 'Content Monetization',
        items: [
          {
            id: 'monetization',
            title: 'Content Monetization',
            content: (
              <>
                There are multiple ways to monetize your content: through Ton.Place Media
                or Erotic Memberships, peresonal Ton.Place Sponsor Memberships, and
                through private messages sales.
              </>
            ),
          },
          {
            id: 'normal',
            title: 'Monetization for Ton.Place Media Creators',
            content: (
              <>
                <b>Daily Payouts</b>
                <ul>
                  <li>
                    Content Creators earn 90% of the total income from Ton.Place Media
                    memberships that is distributed in proportion to the audience’s
                    engagement with the posts.
                  </li>
                  <li>
                    The platform withholds a commission fee of 5%, and those who referred
                    the follower and the content creator each get 2.5%. The total
                    commission is just 10%.
                  </li>
                  <li>
                    Payouts for audience engagement under the posts are deposited to your
                    Ton.Place{' '}
                    <a
                      href="https://ton.place/other?w=balance"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Balance
                    </a>{' '}
                    daily at 8 pm EST.
                  </li>
                </ul>
                <b>Personal Memberships</b>
                <ul>
                  <li>
                    Enable Ton.Place Sponsor Memberships in Settings and set the price.
                  </li>
                  <li>
                    Profit from Sponsor Membership is instantly deposited
                    into your Balance.
                  </li>
                  <li>Ton.Place charges a 10% commission fee.</li>
                </ul>
                <b>Selling Content in Private Messages</b>
                <ul>
                  <li>
                    Sell photos or videos in private messages. You set the price but it
                    must be more than 0.1 TON. The maximum price to set is not limited.
                  </li>
                  <li>
                    Your follower receives the message with the price and hidden content
                    which can be viewed right after making the payment.
                  </li>
                  <li>
                    The platform withholds a commission fee of 5%, and 5% more are
                    directed to rewards for referrals. If you sold a message for 100 TON,
                    you’d receive 90 TON.
                  </li>
                  <li>
                    Payouts for selling private messages are instantly deposited to your
                    Balance on Ton.Place.
                  </li>
                </ul>
                <b>Referral Program</b>
                <ul>
                  <li>
                    Invite friends or followers from other social networks with{' '}
                    <a href="/invite" target="_blank" rel="noreferrer">
                      your unique referral link
                    </a>
                    .
                    <div
                      className="HowTo__image"
                      style={{
                        backgroundImage:
                          'url("' + require('./assets/referral.png').default + '")',
                        paddingTop: '70%',
                      }}
                    />
                  </li>
                  <li>
                    If someone registers via your referral link and buys a membership, you
                    will get 0.4 TON monthly, as well as 2.5% of all their purchases
                    and income.
                  </li>
                </ul>
              </>
            ),
          },
          {
            id: 'adult',
            title: 'Monetization for Ton.Place Erotic Creators',
            content: (
              <>
                <b>Daily Payouts</b>
                <ul>
                  <li>
                    Models earn 90% of the total income from Ton.Place Erotic memberships
                    that is distributed in proportion to the audience’s engagement with
                    the posts.
                  </li>
                  <li>
                    The platform withholds a commission fee of 10% that is directed to
                    maintaining and developing the social network.
                  </li>
                  <li>
                    Payouts for audience engagement under the posts are deposited to your
                    Ton.Place{' '}
                    <a
                      href="https://ton.place/other?w=balance"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Balance
                    </a>{' '}
                    daily at 8 pm EST.
                  </li>
                </ul>
                <b>Selling Content in Private Messages</b>
                <ul>
                  <li>
                    Sell photos or videos in private messages. You set the price but it
                    must be more than 0.1 TON. The maximum price to set is not limited.
                  </li>
                  <li>
                    Your follower receives the message with the price and hidden content
                    which can be viewed right after making the payment.
                  </li>
                  <li>
                    The platform withholds a commission fee of 10%. If you sold a message
                    for 100 TON, you’d receive 90 TON.
                  </li>
                  <li>
                    Payouts for selling private messages are instantly deposited to your{' '}
                    <a
                      href="https://ton.place/other?w=balance"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Balance
                    </a>{' '}
                    on Ton.Place.
                  </li>
                </ul>
              </>
            ),
          },
        ],
      },
      {
        id: 'balance',
        title: 'Balance',
        items: [
          {
            id: 'balance',
            title: 'Balance',
            content: (
              <>
                Daily payouts for audience engagement, private message sales and Sponsor
                Memberships are deposited into your Balance on Ton.Place.
              </>
            ),
          },
          {
            id: 'withdraw',
            title: 'Withdrawals',
            content: (
              <>
                On the left side, click on More, go to{' '}
                <a href="/other?w=balance" target="_blank">
                  Balance
                </a>{' '}
                →{' '}
                <a href="/other?w=withdraw" target="_blank">
                  Withdraw
                </a>
                .
                <br />
                <br />
                You can withdraw funds anytime. Simply enter the amount you need and your
                TON wallet address to receive the funds.
              </>
            ),
          },
          {
            id: 'exchange',
            title: 'How do I exchange TON to EUR, USD, and other currencies?',
            content: (
              <>
                There are multiple ways to exchange TON for regular money:
                <ol>
                  <li>
                    Telegram bot{' '}
                    <a
                      href="https://t.me/CryptoBot?start=r-1325-market"
                      target="_blank"
                      rel="noreferrer"
                    >
                      @CryptoBot
                    </a>{' '}
                    for P2P exchanges.
                  </li>
                  <li>
                    <a href="https://mercuryo.io" target="_blank" rel="noreferrer">
                      Mercuryo
                    </a>{' '}
                    or{' '}
                    <a href="https://neocrypto.net" target="_blank" rel="noreferrer">
                      Neoсrypto
                    </a>{' '}
                    for exchanging right in Tonkeeper app.
                  </li>
                  <li>
                    <a href="https://ftx.com" target="_blank" rel="noreferrer">
                      FTX
                    </a>
                    ,{' '}
                    <a href="https://exmo.me" target="_blank" rel="noreferrer">
                      EXMO
                    </a>
                    ,{' '}
                    <a href="https://okx.com" target="_blank" rel="noreferrer">
                      OKX
                    </a>{' '}
                    exchanges.
                  </li>
                </ol>
              </>
            ),
          },
        ],
      },
      {
        id: 'verification',
        title: 'Verification',
        items: [
          {
            id: 'verification',
            title: 'Verification',
            content: (
              <>
                Verification means that the profile is authentic to the person, brand, or
                business it is representing. It is completely <b>free</b> of charge for
                all users on Ton.Place.
              </>
            ),
          },
          {
            id: 'for_who',
            title: 'Who can get verified?',
            content: (
              <>
                <ul>
                  <li>
                    Popular public figures or communities that share info & entertainment
                    content.
                  </li>
                  <li>
                    18+ Models that enjoy sharing erotic & sexually explicit photos
                    and videos.
                  </li>
                </ul>
              </>
            ),
          },
          {
            id: 'how',
            title: 'How to get verified?',
            content: (
              <>
                You can apply for verification{' '}
                <a href="https://ton.place/verification" target="_blank" rel="noreferrer">
                  here
                </a>
                .
                <br />
                <br />
                The verification process consists of several stages:
                <ol>
                  <li>
                    <b>Moderation Stage</b>. Attach the links to your other social media
                    accounts, and tell a bit about yourself and the content you’re
                    planning to post on Ton.Place.
                  </li>
                  <li>
                    <b>Verification Stage</b>. Fill out an application that is processed
                    by an AI system to verify your identity.
                  </li>
                </ol>
              </>
            ),
          },
        ],
      },
    ],
  },
];

export const HowTo: FC = () => {
  const router = useRouter();
  const { isLogged } = useSelector(authSelector);
  const { route } = useRoute();
  const section = route.params.section || 'none';
  const currentLang = useCurrentLang();
  const t = useTranslator();

  const Data = useMemo(() => {
    if (currentLang.key === 'ru') {
      return DataRU;
    } else {
      return DataEN;
    }
  }, [currentLang]);

  const handleSection = useCallback((section: string, item: string) => {
    const params: any = {};
    if (section !== 'none') {
      params.section = section + '/' + item;
    }
    router.navigate(HOWTO, params, { replace: false });
  }, []);

  const sectionData = useMemo(() => {
    if (section === 'none') {
      return Data;
    } else {
      const exp = section.split('/');
      for (let item of Data) {
        if (item.id === exp[0]) {
          return item;
        }
      }
      return Data;
    }
  }, [section]);

  const sectionItemData = useMemo(() => {
    if (section === 'none') {
      return Data;
    } else {
      const exp = section.split('/');
      for (let item of sectionData.items) {
        if (item.id === exp[1]) {
          return item;
        }
      }
      return Data;
    }
  }, [sectionData, section]);

  useEffect(() => {
    const scroll = document.querySelector('._ScrollView');
    if (scroll) {
      scroll.scrollTop = 0;
    }
  }, [section]);

  function renderContent() {
    if (section === 'none') {
      return (
        <>
          {Data.map((item) => (
            <div key={item.id} className="HowTo__block">
              <InlineHeader>{item.title}</InlineHeader>
              <div className="HowTo__list">
                <List>
                  {item.items.map((row) => (
                    <ListItem
                      key={row.id}
                      icon={<IcChevron16 />}
                      iconSize="small"
                      onClick={() => handleSection(item.id, row.id)}
                    >
                      {row.title}
                    </ListItem>
                  ))}
                </List>
              </div>
            </div>
          ))}
        </>
      );
    } else {
      return (
        <div className="HowTo__content">
          {sectionItemData.items.map((item) => (
            <div className="HowTo__section" key={item.id}>
              <div className="HowTo__section__title">{item.title}</div>
              <div className="HowTo__section__content">{item.content}</div>
            </div>
          ))}
        </div>
      );
    }
  }

  return (
    <>
      <Header showBackButton>
        {section === 'none' ? t('howto_title') : sectionItemData.title}
      </Header>
      <ScrollView>
        {renderContent()}
        <div className="HowTo__support">
          {t('howto_support_tip')}{' '}
          <a href="https://t.me/tonplacehelpbot" target="_blank" rel="noreferrer">
            @tonplacehelpbot
          </a>
        </div>
        {!isLogged && (
          <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
            <Button href="/">{t('howto_sign_in')}</Button>
          </div>
        )}
      </ScrollView>
    </>
  );
};
